import React from 'react';
import { useTranslation } from 'react-i18next';
import { chartTypeLabelKeys } from '@/pages/Overview/ratingsChart';
import type { EvaluationChartType } from '@/types/ratings';

interface Props {
  types: EvaluationChartType[];
  value: EvaluationChartType;
  onChange: (type: EvaluationChartType) => void;
}

export const RatingsSectionTabs: React.FC<Props> = ({
  types,
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <ul className="flex items-center gap-1">
      {types.map((type) => {
        const isActive = type === value;
        return (
          <li key={type} className="shrink-0">
            <button
              type="button"
              onClick={() => onChange(type)}
              className={`flex h-10 cursor-pointer items-center rounded-[24px] px-3 text-subhead-14 whitespace-nowrap transition-colors ${isActive ? 'bg-primary text-primary-foreground shadow-card' : 'text-muted-foreground'}`}
            >
              {t(chartTypeLabelKeys[type])}
            </button>
          </li>
        );
      })}
    </ul>
  );
};
